import gql from "graphql-tag"

const companyNewsTileFragment = gql`
  fragment CompanyNewsTileFragment on CompanyNewsTile {
    config {
      backgroundColor
      columnWidth
      imageUrl
      message
      templateIcon
      templateText
      type
      url
      videoUrl
    }
    xpos
    ypos
  }
`

export default companyNewsTileFragment
